import React from 'react';

import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
  tooltipClasses,
} from '@mui/material';

import { SxProp } from '@hrlogics/react-helper-types';

export const Tooltip: React.FC<React.PropsWithChildren<MuiTooltipProps>> = ({
  children,
  ...props
}) => {
  if (!props.title) return children;

  return (
    <MuiTooltip
      slotProps={{
        tooltip: {
          sx: tooltipStyles,
        },
      }}
      {...props}
    >
      {children}
    </MuiTooltip>
  );
};

const tooltipStyles: SxProp = theme => ({
  backgroundColor: theme.palette.slate?.[500],
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.slate?.[500],
  },
});
